'use client';

import { useCallback, useEffect, useState } from 'react';

import { usePageLoaded } from './use-page-loaded';

const STORAGE_KEY = 'announcementClosed';

const DELAY = 3000;

export function useAnnouncement() {
  const isPageLoaded = usePageLoaded();
  const [isClosed, setIsClosed] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const closed = localStorage.getItem(STORAGE_KEY) === 'true';
    setIsClosed(closed);
  }, []);

  useEffect(() => {
    if (!isPageLoaded) return;

    const timer = setTimeout(() => {
      setIsReady(true);
    }, DELAY);

    return () => clearTimeout(timer);
  }, [isPageLoaded]);

  const close = useCallback(() => {
    setIsClosed(true);
    localStorage.setItem(STORAGE_KEY, 'true');
  }, []);

  return {
    isClosed,
    isReady,
    close,
  };
}
